import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

/**
 * Wrapper for hiding/showing tabber content - intended to be used with
 * the <Tabber /> component.
 * @param {Object} props - The props for the component
 * @param {React.ReactNode} props.children - Children nodes
 * @param {number} props.value - The current index ID to comapre against
 * @param {number} props.index - Index for referencing this tabs ID
 * @component
 * @example
 * return (
 *  <TabberPanel value={0} index={1}>
      Some goodies 🍣
    </TabberPanel>
 * )
 * @see https://mui.com/material-ui/react-tabs/
 */
const TabberPanel = ({ children, value, index, ...other }) => {

  return (
    // 🌎 Container div that toggles the hidden attribute based on the value
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >

      {/* If the value matches the index then render the children */}
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}

    </div>
  );
};

TabberPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number,
  index: PropTypes.number,
};

export default TabberPanel;
